import { createContext, useContext, type ReactNode } from "react";

const RouteLoadNotFoundContext = createContext<(() => ReactNode) | null>(null);

export function RouteLoadNotFoundProvider({
  render,
  children,
}: {
  render: () => ReactNode;
  children: ReactNode;
}) {
  return <RouteLoadNotFoundContext.Provider value={render}>{children}</RouteLoadNotFoundContext.Provider>;
}

export function useRouteLoadNotFound(): (() => ReactNode) | null {
  return useContext(RouteLoadNotFoundContext);
}
